
import React, { useState } from "react";
import { FormDialog } from "@/components/shared/FormDialog";
import { VariantMeasurementForm } from "./VariantMeasurementForm";
import { VariantMeasurementFormValues } from "@/hooks/useVariantMeasurements";

interface VariantMeasurementDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (values: VariantMeasurementFormValues) => Promise<boolean>;
  defaultValues: VariantMeasurementFormValues;
  isEditing: boolean;
  availableProducts?: any[];
}

export function VariantMeasurementDialog({
  open,
  onOpenChange,
  onSubmit,
  defaultValues,
  isEditing,
  availableProducts = []
}: VariantMeasurementDialogProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: VariantMeasurementFormValues) => {
    setIsSubmitting(true);
    try {
      const success = await onSubmit(values);
      if (success) {
        onOpenChange(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <FormDialog
      title={isEditing ? "Edit Variant Measurement" : "Add Variant Measurement"}
      open={open}
      onOpenChange={onOpenChange}
    >
      <VariantMeasurementForm
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        isEditing={isEditing}
        onCancel={handleCancel}
        availableProducts={availableProducts}
      />
    </FormDialog>
  );
}
